<script setup>
import {onMounted, ref, reactive} from "vue";
import YTTablePagination from "@/components/YTTablePagination/YTTablePagination.vue";
import router from "../../router/index.js";
import { listServicePhotography } from "@/api/servicePhotographer/servicePhotographer.js";

/*初次加载*/
onMounted(() => {
  handleSearch()
})

/*搜索功能*/
// 表单数据
const formData = reactive({
  photographyName: '',
});
// 根据表单搜索信息
const handleSearch = async (mode = 'init') => {
  if (mode === 'btnSearch') YTTablePaginationRef.value.resetPage()
  try {
    const param = ref({
      page: YTTablePaginationRef.value.getPage(),
      pageSize: YTTablePaginationRef.value.getPageSize()
    })
    loading.value = true;
    const res = await listServicePhotography(param.value, formData);
    tableData.value = []
    tableData.value = res.list
    total.value = parseInt(res.total)
    loading.value = false
  } catch (e) {
    console.log(e)
    loading.value = false
  }
}
// 清空表单内容
const handleReset = () => {
  formData.photographyName = ''
  handleSearch('btnSearch')
}

/*表格数据展示*/
// 翻页组件锚点
const YTTablePaginationRef = ref()
// 翻页信息：总条目数、加载状态
const total = ref(0)
const loading = ref(false)
const headers = ref([
  {title: '名称', key: 'photographyName', width: "120px", nowrap: true},
  {title: '简称', key: 'photographyShortName', width: "150px", nowrap: true},
  {title: '操作', key: 'controls', width: "20px", fixed: true},
])
// 表格数据
const tableData = ref([])
// 翻页
const handleChangePage = () => {
  handleSearch()
}
// 添加服务项目
const handleAdd = () => {
  router.push({ path: '/editServicePhotographer' })
}

/*操作栏功能*/
// 编辑
const handleEdit = (info) => {
  console.log(info.photographyId, 'handleEdit');
  
  router.push({path: '/editServicePhotographer', query: {photographyId: info.photographyId}})
}

</script>

<template>
  <div class="container_box mg_b_2" style="padding-bottom: 16px">
    <div class="flex_left" style="padding-left: 16px;">
      <v-btn color="success" @click="handleAdd">新建服务摄影师</v-btn>
    </div>
  </div>
  <div class="container_box">
    <v-row justify="center">
      <v-col cols="9">
        <v-data-table
            :headers="headers"
            :items="tableData"
            :loading="loading"
            :items-per-page="$globalPageSize"
            :no-data-text="'没有更多数据了~'"
            hover
        >
          <template v-slot:loading>
            <v-skeleton-loader type="table-row@1"></v-skeleton-loader>
          </template>

          <template v-slot:top>
            <v-form>
              <v-container>
                <v-row justify="center">
                  <v-col cols="3">
                    <v-text-field
                        v-model="formData.photographyName"
                        placeholder="请输入摄影师名称"
                        label="摄影师名称"
                        variant="outlined"
                        clearable
                    ></v-text-field>
                  </v-col>
                  <v-col cols="3" offset="6">
                    <v-row justify="end">
                      <v-col class="flex_right" cols="6">
                        <v-btn color="success" size="large" @click="handleSearch('btnSearch')">搜索
                        </v-btn>
                      </v-col>
                      <v-col class="flex_right" cols="6">
                        <v-btn size="large" @click="handleReset">重置
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
          </template>

          <template v-slot:item.controls="{ item }">
            <div class="flex_left flex_align_b">
              <el-tooltip
                  class="box-item"
                  effect="dark"
                  content="编辑"
                  placement="top">
                <v-icon class="cursor-pointer mg_r_1" icon="mdi-file-edit-outline" size="small" color="primary" @click="handleEdit(item)"></v-icon>
              </el-tooltip>
            </div>
          </template>

          <template v-slot:bottom>
            <YTTablePagination ref="YTTablePaginationRef" :page-size="$globalPageSizeHalf" :total="total" @page-change="handleChangePage"></YTTablePagination>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>

<style scoped>

</style>
